import React from 'react';
import Input from './input';
//import Form from './form2';
import Button from './button';

export default class AdvancedSearch extends React.Component {

    get fields() {
        return this.props.fields || [];
    }

    get values() {
        return this.props.values || {};
    }

    handleSearch(event, data = this.values) {

        event.preventDefault();
        if(typeof this.props.onSearch === 'function') {
            this.props.onSearch(data);
        }
    }

    handleFieldChange(e, key) {
        const value = e.target.value;
        const values = {};

        values[key] = value;
        values[key + 'Compare'] = 'Contains';

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(e, Object.assign({}, this.values, values));
        }
    }

    render() {

        return (
            <div className={['component-advanced-search', this.props.className].join(' ')}>
                <form className="advanced-form" onSubmit={(e) => this.handleSearch(e)}>
                    <div className="search-fields">
                        { this.fields.map((field, i) => (
                            <div key={i} className="col-sm-4 search-field">
                                <div className="form-group">
                                    <label className="form-control">{field.name}</label>
                                    <Input 
                                        className="form-control" 
                                        name={field.key} 
                                        onChange={(e) => this.handleFieldChange(e, field.key)}
                                        value={this.values[field.key] || ''} />
                                </div>
                            </div>
                        )) }
                        <div className="clearfix"></div>
                    </div>
                    <Button className="primary pull-right clear-margin icon-left" onClick={(e) => this.handleSearch(e) }>
                        <span className="icon-desktop-search"></span><span className="label">Search</span>
                    </Button>
                </form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./web-app/components/advanced-search.jsx